import { ResponsiveComponentProps, ResponsiveWrapper } from '../ResponsiveWrapper';
import { BarPieChartBase, BarPieChartBaseProps } from './BarPieChartBase';

export type ResponsiveBarPieChartBaseProps = ResponsiveComponentProps<BarPieChartBaseProps>;

export function ResponsiveBarPieChartBase({
  width: overrideWidth,
  height: overrideHeight,
  ...componentProps
}: ResponsiveBarPieChartBaseProps) {
  return (
    <ResponsiveWrapper width={overrideWidth} height={overrideHeight}>
      {({ width, height }) => {
        return <BarPieChartBase width={width} height={height} {...componentProps} />;
      }}
    </ResponsiveWrapper>
  );
}
